import script from "./card-with-slidedown.vue?vue&type=script&setup=true&lang=js"
export * from "./card-with-slidedown.vue?vue&type=script&setup=true&lang=js"

import "./card-with-slidedown.vue?vue&type=style&index=0&id=6b794fa8&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b794fa8"]])

export default __exports__